export default {
	noConnectionError: "Connection lost. Attempting to reconnect. Changes to shared or private notes are not currently being saved.",
	reconnectedMessage: "Connection restored.",
};
